import {
  actualizarSiteSetting,
  obtenerSiteSettingsMap,
} from "@/services/siteSettings/siteSettingsService";

const KEYS = {
  authorities: "federation.authorities",
  groups: "federation.groups",
  documents: "federation.documents",
};

function parseJson(value, fallback) {
  try {
    const parsed = JSON.parse(value || "");
    return Array.isArray(parsed) ? parsed : fallback;
  } catch (_) {
    return fallback;
  }
}

export async function obtenerFederationContent() {
  const settings = await obtenerSiteSettingsMap();
  return {
    authorities: parseJson(settings[KEYS.authorities], []),
    groups: parseJson(settings[KEYS.groups], []),
    documents: parseJson(settings[KEYS.documents], []),
  };
}

export async function guardarFederationContent(content) {
  await Promise.all([
    actualizarSiteSetting(KEYS.authorities, {
      label: "Federación - autoridades",
      group: "federation",
      value: JSON.stringify(content.authorities || []),
    }),
    actualizarSiteSetting(KEYS.groups, {
      label: "Federación - miembros",
      group: "federation",
      value: JSON.stringify(content.groups || []),
    }),
    actualizarSiteSetting(KEYS.documents, {
      label: "Federación - documentos",
      group: "federation",
      value: JSON.stringify(content.documents || []),
    }),
  ]);
}
